import curatorApiManager from './api/curator';
import therapistApiManager from './api/therapist';
import clientApiManager from './api/client';

import RepositoryModule from './vuex/index';

let curator = new RepositoryModule(curatorApiManager);
let therapist = new RepositoryModule(therapistApiManager);
let client = new RepositoryModule(clientApiManager);

export default {
  curator: {
    namespaced: true,
    modules: {
      repository: curator,
    },
  },
  therapist: {
    namespaced: true,
    modules: {
      repository: therapist,
    },
  },
  client: {
    namespaced: true,
    modules: {
      repository: client,
    },
  },
};


// WEBPACK FOOTER //
// ./src/modules/user/index.js